import { render, staticRenderFns } from "./Registro.vue?vue&type=template&id=1b6f5f5c&"
import script from "./Registro.vue?vue&type=script&lang=ts&"
export * from "./Registro.vue?vue&type=script&lang=ts&"
import style0 from "./Registro.vue?vue&type=style&index=0&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports